import React from 'react'

const Token = () => {
  console.log(window.location)
  return (
    <div>Token</div>
  )
}

export default Token